import React, { useEffect, useState, useMemo } from "react";
import { getData } from "../../../../../services/library";
import Container from "@mui/material/Container";
import { MRT_Localization_ES } from "material-react-table/locales/es";
import MaterialReactTable from "material-react-table";
import DetailPanel from "./DetailPanel";
import { Grid, Button } from "@mui/material";
import NuevoReclamo from "../../../../granel/reclamos/NuevoReclamo";

function ReclamosCli(props) {
  const [reclamos, setReclamos] = useState(null);
  const [showTable, setShowTable] = useState(true);
  const [bgColorTableHeadCell, setBgColorTableHeadCell] = useState(
    props.soloLectura ? "#ebebeb" : "#D4E6F1"
  );
  const [addReclamo, setAddReclamo] = useState(false);

  useEffect(() => {
    getData("/reclamos/cliente/" + props.cliente.id, setReclamos);
  }, []);

  //  console.log("reclamos", reclamos);
  // console.log("solo lectura", props.soloLectura);
  //console.log("CLIENTE", props.cliente);

  // TABLA:
  const columns = useMemo(
    () => [
      {
        accessorKey: "id_reclamo",
        header: "N°",
        maxSize: 7,
      },
      {
        accessorKey: "descripcion_motivo",
        header: "Motivo",
        minSize: 200,
      },
      {
        accessorKey: "fecha_abierto",
        header: "Fecha Apertura",
        minSize: 200,
      },
      {
        accessorKey: "descr_estado",
        header: "Estado",
        minSize: 200,
      },
      {
        accessorKey: "direccion_entrega",
        header: "Domicilio",
      },
    ],
    []
  );

  const displayColumnDefOptions = {
    "mrt-row-actions": {
      muiTableHeadCellProps: {
        sx: {
          fontSize: 14,
          color: "black",
          fontWeight: "normal",
          paddingTop: 1,
          paddingBottom: 1,
          backgroundColor: bgColorTableHeadCell,
          borderColor: "#FDFEFE",
        },
      },
      size: 60,
    },
  };

  const initialState = {
    density: "compact",
    showGlobalFilter: true,
    pagination: {
      pageSize: 8,
      pageIndex: 0,
    },
  };

  const tableHeadCellProps = {
    align: "left",
    sx: {
      fontSize: 14,
      color: "black",
      fontWeight: "normal",
      backgroundColor: bgColorTableHeadCell,
      borderColor: "#FDFEFE",
    },
  };

  const handleClickNuevo = () => {
    setAddReclamo(true);
    setShowTable(false);
  };

  const handleVolver = () => {
    showTable(true);
    addReclamo(false);
    // getData("/reclamos/cliente/" + props.cliente.id, setReclamos);
  };

  const handleRefrescarTabla = () => {
    getData("/reclamos/cliente/" + props.cliente.id, setReclamos);
  };

  return (
    <div>
      {showTable && reclamos && (
        <Container maxWidth="xl" disableGutters mb={10}>
          <MaterialReactTable
            localization={MRT_Localization_ES}
            enableTopToolbar={true}
            columns={columns}
            data={reclamos}
            enableColumnFilterModes={false}
            enableColumnOrdering={false}
            enableGrouping={false}
            enablePinning
            initialState={initialState}
            enableRowSelection={false}
            positionActionsColumn="last"
            enableHiding={false}
            muiTableHeadCellProps={tableHeadCellProps}
            positionExpandColumn="first"
            renderDetailPanel={({ row }) => (
              <DetailPanel reclamo={row.original} />
            )}
            enableExpandAll={false}
            muiTableBodyCellProps={({ row }) => ({
              align: "left",
              sx: {
                backgroundColor: "#ffffff",
                color: "black",
                borderColor: "#FDFEFE",
              },
            })}
            renderTopToolbarCustomActions={() => (
              <>
                {!props.soloLectura && (
                  <Button
                    variant="contained"
                    color="secondary"
                    size="small"
                    onClick={handleClickNuevo}
                  >
                    Nuevo Reclamo
                  </Button>
                )}
              </>
            )}
            enableColumnActions={false}
            enableColumnFilters={false} //Quita filtros por columna
            displayColumnDefOptions={displayColumnDefOptions}
            enableDensityToggle={false}
          />
        </Container>
      )}
      {addReclamo ? (
        <NuevoReclamo
          addReclamo={setAddReclamo}
          tabla={setShowTable}
          dataCliente={props.cliente}
          onClose={handleVolver}
          onRefresh={handleRefrescarTabla}
        />
      ) : null}
    </div>
  );
}

export default ReclamosCli;
